import { render } from "./Contact_en.vue?vue&type=template&id=486cc7ee&scoped=true"
import script from "./Contact_en.vue?vue&type=script&lang=js"
export * from "./Contact_en.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-486cc7ee"

export default script